import classNames from 'classnames';
import styles from './../ContentStyles.module.css';
export const NewCard = () => {
  return <div className={classNames([styles.cardContent, styles.newCard])} data-sentry-component="NewCard" data-sentry-source-file="NewCard.tsx">
      <h1>New Guide</h1>
      <p style={{
      marginBottom: '4rem'
    }}>
        Click 'Edit Card' below to begin adding content
      </p>
    </div>;
};